export let config = {
	imageMap: {
		src: "/apps/configurators/cii-regulations/assets/images/transport-ship.svg",
		items: [
			{
				id: 1,
				position: {
					top: 75,
					left: 1,
				},
				title: {
					en: "Propeller solutions",
					de: "Propeller solutions",
				},
				links: [
					{
						id: 1,
						title: {
							en: "See CP propeller upgrade solution",
							de: "See CP propeller upgrade solution",
						},
						href: "https://www.everllence.com/services/offerings/marine-power/retrofit-upgrade/regulations#propeller",
					},
					{
						id: 2,
						title: {
							en: "See EcoOptimizer",
							de: "See EcoOptimizer",
						},
						href: "https://www.everllence.com/services/offerings/marine-power/retrofit-upgrade/regulations#propeller",
					},
					{
						id: 3,
						title: {
							en: "Go to propeller & aft ship retrofit solutions",
							de: "Go to propeller & aft ship retrofit solutions",
						},
						href: "https://www.everllence.com/services/offerings/marine-power/retrofit-upgrade/propeller-aft-ship/",
						target: "_blank",
					},
				],
			},
			{
				id: 2,
				position: {
					top: 75,
					left: 24,
				},
				title: {
					en: "Turbocharger solutions",
					de: "Turbocharger solutions",
				},
				links: [
					{
						id: 1,
						title: {
							en: "See turbocharger solutions",
							de: "See turbocharger solutions",
						},
						href: "https://www.everllence.com/services/offerings/marine-power/retrofit-upgrade/regulations#propeller",
					},
					{
						id: 2,
						title: {
							en: "Go to turbocharger retrofit",
							de: "Go to turbocharger retrofit",
						},
						href: "https://www.man-es.com/services/industries/marine/retrofit-upgrade/turbocharger-exhaust-gas-treatment",
						target: "_blank",
					},
					{
						id: 3,
						title: {
							en: "Go to turbocharger products overview",
							de: "Go to turbocharger products overview",
						},
						href: "https://www.everllence.com/marine/products/turbocharger",
						target: "_blank",
					},
				],
			},
			{
				id: 3,
				position: {
					top: 75,
					left: 48.5,
				},
				title: {
					en: "Two-stroke solutions",
					de: "Two-stroke solutions",
				},
				links: [
					{
						id: 1,
						title: {
							en: "See MC/MC-C retrofit solutions",
							de: "See MC/MC-C retrofit solutions",
						},
						href: "https://www.everllence.com/services/offerings/marine-power/retrofit-upgrade/regulations#Two-Stroke",
					},
					{
						id: 2,
						title: {
							en: "See ME/ME-B/ME-C retrofit solutions",
							de: "See ME/ME-B/ME-C retrofit solutions",
						},
						href: "https://www.everllence.com/services/offerings/marine-power/retrofit-upgrade/regulations#Two-Stroke",
					},
					{
						id: 3,
						title: {
							en: "See spare Part Solutions",
							de: "See spare Part Solutions",
						},
						href: "https://www.everllence.com/services/offerings/marine-power/retrofit-upgrade/regulations#Two-Stroke",
					},
					{
						id: 4,
						title: {
							en: "Go to two-stroke retrofits overview",
							de: "Go to two-stroke retrofits overview",
						},
						href: "https://www.everllence.com/services/offerings/marine-power/retrofit-upgrade",
						target: "_blank",
					},
				],
			},
			{
				id: 4,
				position: {
					top: 75,
					left: 71,
				},
				direction: "left",
				title: {
					en: "Four-stroke solutions",
					de: "Four-stroke solutions",
				},
				links: [
					{
						id: 1,
						title: {
							en: "See roadmap solutions",
							de: "See roadmap solution",
						},
						href: "https://www.everllence.com/services/offerings/marine-power/retrofit-upgrade/regulations#Four-Stroke",
					},
					{
						id: 2,
						title: {
							en: "See retrofit solutions",
							de: "See retrofit solutions",
						},
						href: "https://www.everllence.com/services/offerings/marine-power/retrofit-upgrade/regulations#Four-Stroke",
					},
					{
						id: 3,
						title: {
							en: "See spare part solutions",
							de: "See spare part solutions",
						},
						href: "https://www.everllence.com/services/offerings/marine-power/retrofit-upgrade/regulations#Four-Stroke",
					},
					{
						id: 4,
						title: {
							en: "Go to four-stroke retrofits overview",
							de: "Go to four-stroke retrofits overview",
						},
						href: "https://www.everllence.com/marine/campaigns/retrofit-four-stroke",
						target: "_blank",
					},
				],
			},
		],
	},
};
